import React from 'react';
import styled from 'styled-components';
import { FiTrash2, FiShoppingCart } from 'react-icons/fi';
import { Sizes } from '../utils/sizes';
import { Colors } from '../utils/colors';

const CartContainerStyle = styled.div`
  width: 100%;
  background: linear-gradient(135deg, rgba(20, 20, 20, 0.7) 0%, rgba(20, 20, 20, 0.5) 100%);
  border: 2px solid ${Colors.gold};
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 30px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    padding: 16px;
  }

  & h3 {
    color: ${Colors.yellow};
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    letter-spacing: 0.3px;

    & .item-count {
      background: ${Colors.yellow};
      color: ${Colors.dark};
      padding: 4px 12px;
      border-radius: 50%;
      font-size: 13px;
      font-weight: 900;
      box-shadow: 0 2px 8px rgba(255, 193, 0, 0.3);
    }
  }

  & .cart-items {
    display: flex;
    flex-direction: column;
    gap: 14px;
    max-height: 500px;
    overflow-y: auto;
    margin-bottom: 20px;
    padding-right: 8px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.08);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${Colors.yellow};
      border-radius: 3px;

      &:hover {
        background: ${Colors.gold};
      }
    }
  }

  & .cart-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background: linear-gradient(90deg, rgba(255, 193, 13, 0.06) 0%, rgba(255, 193, 13, 0.02) 100%);
    border: 1px solid rgba(255, 193, 0, 0.2);
    border-left: 4px solid ${Colors.yellow};
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(90deg, rgba(255, 193, 13, 0.1) 0%, rgba(255, 193, 13, 0.04) 100%);
      border-color: rgba(255, 193, 0, 0.35);
    }

    & .item-info {
      flex: 1;
      min-width: 0;

      & .item-title {
        color: ${Colors.white};
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 6px;
        word-wrap: break-word;
      }

      & .item-price {
        color: ${Colors.yellow};
        font-size: 13px;
        font-weight: 800;
        letter-spacing: 0.2px;
      }
    }

    & .item-actions {
      display: flex;
      gap: 10px;
      align-items: center;
      margin-left: 12px;

      & .remove-btn {
        background: rgba(239, 68, 68, 0.15);
        border: 1px solid rgba(239, 68, 68, 0.3);
        color: #ef4444;
        padding: 6px 12px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 11px;
        font-weight: 700;
        transition: all 0.3s ease;
        white-space: nowrap;

        &:hover {
          background: rgba(239, 68, 68, 0.25);
          border-color: rgba(239, 68, 68, 0.5);
        }

        &:active {
          transform: scale(0.98);
        }
      }
    }
  }

  & .empty-cart {
    text-align: center;
    padding: 60px 20px;
    color: ${Colors.textSecondary};

    & p {
      margin: 12px 0;
      font-size: 14px;
      line-height: 1.6;
    }
  }

  & .cart-summary {
    border-top: 1px solid rgba(255, 193, 0, 0.25);
    padding-top: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & .summary-label {
      color: ${Colors.white};
      font-size: 15px;
      font-weight: 600;
    }

    & .summary-value {
      color: ${Colors.yellow};
      font-size: 22px;
      font-weight: 900;
      letter-spacing: -0.3px;
    }
  }
`;

export const Cart = ({ items, onRemove, onUpdateQuantity, totalPrice }) => {
  const formatPrice = (price) => {
    return `R$ ${(price / 100).toFixed(2).replace('.', ',')}`;
  };

  return (
    <CartContainerStyle>
      <h3>
        Carrinho
        <span className="item-count">{items.length}</span>
      </h3>

      {items.length === 0 ? (
        <div className="empty-cart">
          <FiShoppingCart style={{ fontSize: 32, opacity: 0.5, marginBottom: 4 }} />
          <p>Seu carrinho está vazio</p>
          <p>Explore nossos eBooks e tablaturas</p>
        </div>
      ) : (
        <>
          <div className="cart-items">
            {items.map((item) => (
              <div key={item.id} className="cart-item">
                <div className="item-info">
                  <div className="item-title">{item.title}</div>
                  <div className="item-price">{formatPrice(item.price)}</div>
                </div>
                <div className="item-actions">
                  <button className="remove-btn" onClick={() => onRemove(item.id)}>
                    <FiTrash2 style={{ verticalAlign: '-2px', marginRight: 4 }} />Remover
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <span className="summary-label">Total:</span>
            <span className="summary-value">{formatPrice(totalPrice)}</span>
          </div>
        </>
      )}
    </CartContainerStyle>
  );
};

export default Cart;
